<template>
  <div
    class="select-month"
    :style="{
      height: `${pagesHeight}px`,
      overflow: 'hidden'
    }"
  >
    <div
      :style="{
        width: '1920px',
        height: '1080px',
        transformOrigin: 'left top',
        transform: `scale(${scalseNum})`,
        '-webkit-transform': `scale(${scalseNum})`,
        '-moz-transform': `scale(${scalseNum})`,
        '-o-transform': `scale(${scalseNum})`,
        '-ms-transform': `scale(${scalseNum})`
      }"
    >
      <div class="select-box">
        <div class="select-title">选择数据月份</div>
        <div class="year">
          <div class="select-y">
            <!-- <h3
              class="y"
              :class="{
                selectItem: selectYear == 2021
              }"
              @click="haldleSelectYear(2021)"
              v-focusable
              :key="'y_' + 2021"
              :ref="`y_${2021}`"
              @left="contentYearLeft(2021)"
              @down="contentYearDown(2021)"
            >
              2021年
            </h3>
            <h3
              class="y"
              :class="{
                selectItem: selectYear == 2022
              }"
              @click="haldleSelectYear(2022)"
              v-focusable
              :key="'y_' + 2022"
              :ref="`y_${2022}`"
              @right="contentYearRight(2022)"
              @down="contentYearDown(2022)"
            >
              2022年
            </h3> -->
            <h3
              v-for="y in years"
              class="y"
              :class="{
                selectItem: selectYear == y
              }"
              @click="haldleSelectYear(y)"
              v-focusable
              :key="`y_${y}`"
              :ref="`y_${y}`"
              @left="contentYearLeft(y)"
              @right="contentYearRight(y)"
              @down="contentYearDown(y)"
            >
              {{ y }}年
            </h3>
          </div>
          <ul class="month cf" v-if="selectMonth">
            <template v-for="num in 12">
              <li
                :key="'m_' + num"
                v-if="num <= month"
                class="item"
                v-focusable
                :class="{
                  selectItem: num === parseInt(selectMonth)
                }"
                :ref="`m_${num}`"
                @up="contentUp(num)"
                @down="contentDown(num)"
                @left="contentLeft(num)"
                @right="contentRight(num)"
                @click="haldleSelectMonth(num)"
              >
                {{ num }}月
              </li>
              <li :key="'m_' + num" v-else>{{ num }}月</li>
            </template>
          </ul>
        </div>
        <div class="select-btn">
          <div class="select-btn__container">
            <div class="sbtn" ref="ok" @up="selectUp" @click="handleOk" v-focusable>确定</div>
            <div class="sbtn" ref="back" @up="selectUp" @click="handleBack" v-focusable>返回</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ccMapMixin from '@/mixins/ccmap'
import scalseNum from '@/mixins/scalseNum.js'
import store from '@/store'
export default {
  mixins: [scalseNum],
  data() {
    return {
      selectYear: '',
      selectMonth: '',
      years: [2021, 2022, 2023, 2024, 2025]
    }
  },
  computed: {
    isAndroid() {
      return this.$store.state.app.isAndroid
    },
    year() {
      const date = new Date()
      return date.getFullYear()
    },
    month() {
      const date = new Date()
      // if (+this.selectYear !== date.getFullYear()) {
      //   return 12
      // }
      // let month = date.getMonth() + 1
      // month = month < 10 ? '0' + month : month
      // return month
      let month = date.getMonth() + 1
      if (+this.selectYear < date.getFullYear()) {
        return 12
      } else if (+this.selectYear === date.getFullYear()) {
        return month
      } else {
        return 0
      }
    }
  },
  methods: {
    contentYearDown() {
      this.$tv.requestFocus(this.$refs[`m_0`])
    },
    contentYearLeft(val) {
      if (val === this.years[0]) {
        this.$tv.requestFocus(this.$refs[`y_${++val}`])
      }
    },
    contentYearRight(val) {
      if (val === this.years[this.years.length - 1]) {
        this.$tv.requestFocus(this.$refs[`y_${--val}`])
      }
    },
    resertMonth() {
      this.selectMonth = '01'
    },
    haldleSelectYear(year) {
      this.selectYear = year
      this.resertMonth()
      setTimeout(() => {
        this.$tv.requestFocus(this.$refs[`y_${year}`])
        this.$tv.requestFocus(this.$refs[`m_${parseInt(this.selectMonth)}`])
      }, 100)
    },
    selectUp() {
      this.$tv.requestFocus(this.$refs[`m_${this.month}`])
    },
    contentUp(i) {
      const after = i % 6
      this.$tv.requestFocus(this.$refs[`m_${after === 0 ? i : after}`])
    },
    contentDown(i) {
      const downI = i + 6
      this.$tv.requestFocus(this.$refs[i > 6 ? 'ok' : `m_${downI <= this.month ? downI : this.month}`])
    },
    contentLeft(i) {
      const after = i - 1
      this.$tv.requestFocus(this.$refs[`m_${after > 0 ? after : 1}`])
    },
    contentRight(i) {
      const after = i + 1
      if (after <= this.month) {
        this.$tv.requestFocus(this.$refs[`m_${after}`])
      } else {
        this.$tv.requestFocus(this.$refs.ok)
      }
    },
    haldleSelectMonth(num) {
      if (num <= this.month) {
        num < 10 ? (this.selectMonth = '0' + num) : (this.selectMonth = num)
        setTimeout(() => {
          this.$tv.requestFocus(this.$refs[`m_${num}`])
        }, 100)
      }
    },
    handleBack() {
      if (this.selectYear === 2022) {
        this.$store.commit('router/SET_ROUTER_NAME')
      } else {
        this.$store.commit('router/SET_ROUTER_NAME', this.selectYear)
      }
      const returnPage = localStorage.getItem('returnPage')
      window.location = returnPage || '/'
      localStorage.removeItem('returnPage')
    },
    handleOk() {
      const date = {
        time: `${this.selectYear}-${this.selectMonth}`,
        isCurMonth: parseInt(this.selectMonth) === this.month
      }
      sessionStorage.setItem('toggleDate', JSON.stringify(date))
      this.handleBack()
    }
  },
  mounted() {},
  activated() {
    // const month = JSON.parse(sessionStorage.getItem('toggleDate')).time.substr(5)
    const Time = JSON.parse(sessionStorage.getItem('toggleDate')).time.split('-')
    this.selectYear = +Time[0]
    this.selectMonth = Time[1]
    this.$nextTick(() => {
      this.$tv.requestFocus(this.$refs[`m_${parseInt(this.selectMonth)}`])
    })
  }
}
</script>

<style lang="stylus" scoped>
h3
  margin 0
  padding 0
.select-month
  width 100%
  height 100vh
  color #fff
  background url('~@/assets/images/select-month-bg.jpg')
  background-size 100%
  position relative
.select-title
  font-size 2.2rem
  text-align center
.select-box
  position absolute
  width 43.8rem
  height 27.5rem
  background #34373E
  left 50%
  top 50%
  margin-left -22.5%
  margin-top -13.75rem
  padding 2.5rem
  box-sizing border-box
  border-radius .8rem
.year
  width 100%
  h3.y
    font-size 1.6rem
    font-weight normal
    margin 2rem 1rem 1rem -0.1rem
    color: rgba(255,255,255,0.3);
ul.month
  margin 0
  padding 0
  margin 0 -0.2rem
  li
    width 6rem
    height 2.5rem
    line-height 2.5rem
    font-size 1.4rem
    text-align center
    margin 0 .2rem .4rem
    background rgba(255,255,255,.1)
    border-radius .3rem
    border 1px solid rgba(255,255,255,.0)
    box-sizing border-box
    background-repeat no-repeat !important
    background-position right top
    display inline-block
    color rgba(255,255,255,.3)
  .item
    color #fff
    cursor pointer
  .selectItem
    border 1px solid #007EFF
    background url('~@/assets/images/blue-corner.png') no-repeat right top
  .selectItem.btnFocus
    background-image url('~@/assets/images/white-corner.png') !important
.select-btn
  margin-top 4.2rem
  .select-btn__container
    display flex
    .sbtn
      flex 1
      text-align center
      height 4.5rem
      line-height 4.5rem
      background rgba(255,255,255,.1)
      border-radius .8rem
      cursor pointer
      &:first-child
        margin-right .75rem
      &:last-child
        margin 0 .2rem 0 .75rem
.btnFocus
  background-color #007eff !important

.select-y
  display flex
  .y
    cursor pointer
    &.selectItem
      color #fff
      cursor auto
</style>
